<template>
	<AppLayout
		:title="trans('rotations.periods.edit.title')"
		:return-url="route('association.representatives.periods.index')"
		:return-label="trans('rotations.periods.title')"
	>
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-save mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
			<LabeledObject required>
				<template #label>{{ trans('rotations.periods.begins_on') }}</template>
				<IconDateInput v-model="period.begins_on" icon-class="fa-solid fa-hourglass-start" :min="min" full/>
			</LabeledObject>
			<LabeledObject required>
				<template #label>{{ trans('rotations.periods.ends_on') }}</template>
				<IconDateInput v-model="period.ends_on" icon-class="fa-solid fa-hourglass-end" :min="period.begins_on" full/>
			</LabeledObject>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import AppLayout from '@/Layouts/AppLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import IconDateInput from '@/Components/UI/Inputs/IconDateInput.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import {type RotationPeriod} from '@/Types/Periods/Rotations/RotationPeriod'

const props = defineProps<{
	period:RotationPeriod,
}>()

const period:Ref<RotationPeriod> = ref(props.period)
const working:Ref<boolean> = ref(false)
const min = ref(dayjs().format('YYYY-MM-DD'))

function update():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('association.representatives.periods.update', period.value.id), period.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>